module.exports = __webpack_public_path__ + "img/dispenser.0514ee13.svg";